import React, { useState, useCallback, useEffect } from 'react'
import updateRA from 'immutability-helper'
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl'
import GridList from '../GridList'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

import {
  CapitalButton,
} from '../Navigation/Buttons'

import {
  SelectInput,
} from '../Inputs/Inputs'

import AppStore from '../../../stores/AppStore'

import styles from '../../../../css/home.module.css'
import styleGrid from '../../../../css/devicePage.module.css'

function ExistingCustomerStep2 ({
  intl: { formatMessage, locale },
  defaultToGroup,
  defaultFromGroup,
  defaultSelectedState,
  company,
  data,
  groups,
  customerOptions,
  step2Callback,
  onSubmit,
}) {
  const [language, setLanguage] = useState(locale)
  const [invalid, setInvalid] = useState(true)
  const [saved, setSaved] = useState(false)
  const [toGroup, setToGroup] = useState(defaultToGroup)
  const [fromGroup, setFromGroup] = useState(defaultFromGroup)
  const [selectAll, setSelectAll] = useState(false)
  const [selectedState, setSelectedState] = useState({})

  const getData = useCallback(() => {
    const userID = data.user.id
    AppDispatcher.dispatch({
      action: 'get-searched-customer',
      customerID: company,
      userID,
    })
  }, [company, data.user.id])

  const getNewData = useCallback((group) => {
    const { id: customerID } = AppStore.getCustomer()

    const action = {
      action: 'get-devices',
      groupID: group,
      customerID,
    }
    AppDispatcher.dispatch(action)
  }, [])

  const isValid = useCallback(() => {
    const data = AppStore.getData()
    const deviceValid = data.deviceSettings.devices.length > 0

    if (((toGroup !== '') && (fromGroup !== '') && (deviceValid)) || ((defaultFromGroup !== '') && (defaultToGroup !== '') && (deviceValid))) {
      setInvalid(false)
    } else {
      setInvalid(true)
    }
  }, [toGroup, fromGroup, defaultFromGroup, defaultToGroup])

  const clickSelectAll = useCallback(() => {
    const allNotSelected = Object.keys(selectedState).every((k) => !selectedState[k])
    const anySelected = Object.keys(selectedState).some((k) => selectedState[k])

    let newSelectAll = selectAll
    if (allNotSelected && selectAll === true) {
      newSelectAll = true
    } else if (anySelected) {
      newSelectAll = false
    } else {
      newSelectAll = !selectAll
    }

    setSelectAll(newSelectAll)
    selectAllDevices(newSelectAll)
  }, [selectAll, selectedState])

  const selectAllDevices = useCallback((newSelectAll) => {
    const deviceData = data.groupDevices
    const { devices } = deviceData || {}

    const devicesSelected = []
    const newSelectedState = {}
    devices.forEach((device) => {
      newSelectedState[device.id] = newSelectAll
      if (newSelectAll === true) {
        devicesSelected.push(device.id)
      }
    })

    setSelectedState(newSelectedState)

    if (newSelectAll) {
      AppDispatcher.dispatch({
        action: 'select-multiple-devices',
        ids: devicesSelected,
      })
    } else {
      AppDispatcher.dispatch({
        action: 'selected-devices-remove-all',
      })
    }

    isValid()
  }, [data.groupDevices, isValid])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
    if (event.target.name === 'fromGroup') {
      getNewData(event.target.value)
    }
  }, [getNewData])

  const handleChange = useCallback((field, value) => {
    const newValue = value

    // Update the appropriate state based on field
    if (field === 'language') setLanguage(newValue)
    if (field === 'invalid') setInvalid(newValue)
    if (field === 'saved') setSaved(newValue)
    if (field === 'toGroup') setToGroup(newValue)
    if (field === 'fromGroup') setFromGroup(newValue)
    if (field === 'selectAll') setSelectAll(newValue)
    if (field === 'selectedState') setSelectedState(newValue)

    isValid()
  }, [isValid])

  const submitData = useCallback(() => {
    step2Callback(fromGroup, toGroup, selectedState)
  }, [fromGroup, toGroup, selectedState, step2Callback])

  useEffect(() => {
    getData()
    isValid()
  }, [getData, isValid])

  useEffect(() => {
    if (!defaultFromGroup || !defaultToGroup) {
      AppDispatcher.dispatch({
        action: 'unload-group-devices',
      })
      AppDispatcher.dispatch({
        action: 'selected-devices-remove-all',
      })
    }
    if (defaultSelectedState) {
      setSelectedState(defaultSelectedState)
      setInvalid(false)
    }
  }, [defaultFromGroup, defaultToGroup, defaultSelectedState])

  let saveButtonStyle = `${styles.saveButton} saveButton`

  if (invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton`
  } else if (saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  const deviceData = data.groupDevices
  const { ready, devices } = deviceData || {}
  const searchedGroupsData = AppStore.getSearchedGroups()
  const searchedGroups = searchedGroupsData.groups || []

  const SelectGroup = formatMessage({
    id: 'customer.transferDevices.selectGroup',
    defaultMessage: 'Select Group',
    description: 'Select Group label',
  })

  const groupFromOptions = [{
    value: '',
    name: SelectGroup,
    disabled: true,
  }]

  groups
    .map(
      (group) => groupFromOptions.push({
        value: group.groupID,
        name: group.name,
      })
    )

  const groupToOptions = [{
    value: '',
    name: SelectGroup,
    disabled: true,
  }]
  searchedGroups
    .map(
      (group) => groupToOptions.push({
        value: group.groupID,
        name: group.name,
      })
    )

  const tileSetInfo = 'default'

  const noDevicesMessage = formatMessage({
    id: 'customer.transferDevices.noDevices',
    defaultMessage: 'No devices found in this group',
    description: 'Shown when the selected group has no devices to transfer',
  })

  let gridList = <div />
  if (deviceData && ready && Array.isArray(devices)) {
    gridList = devices.length > 0
      ? (
        <GridList
          devices={devices}
          sort={data.sort}
          selectMode
          tileInfo={tileSetInfo}
          callback={isValid}
          selectedStateAll={selectedState}
          onSelectionChange={setSelectedState}
        />
        )
      : (
        <p className={styleGrid.emptySetting} style={{ textAlign: 'center' }}>{noDevicesMessage}</p>
        )
  }

  const allNotSelected = Object.keys(selectedState).every((k) => !selectedState[k])
  const anySelected = Object.keys(selectedState).some((k) => selectedState[k])
  let id = 'setting.select.all'
  let message = 'Select All'
  let buttonStyles = styleGrid.selectAllButton
  if (selectAll && !allNotSelected) {
    id = 'setting.select.none'
    message = 'Deselect All'
    buttonStyles = styleGrid.saveButton
  } else if (anySelected) {
    id = 'setting.select.none'
    message = 'Deselect All'
    buttonStyles = styleGrid.saveButton
  } else if (allNotSelected) {
    id = 'setting.select.all'
    message = 'Select All'
    buttonStyles = styleGrid.selectAllButton
  }

  const selectAllButton = deviceData && ready && Array.isArray(devices) && devices.length > 0
    ? (
      <div className={styles.selectAllButtonStyle}>
        <CapitalButton
          text={formatMessage({
            id,
            defaultMessage: message,
            description: '',
          }).toUpperCase()}
          buttonFunction={clickSelectAll}
          hSize='h5'
          style={`${buttonStyles} ${styleGrid.selectAllButtonStyles}`}
        />
      </div>
      )
    : (
      <div />
      )

  return (
    <div>
      <div className={styles.userInviteInput}>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.fromGroup'
            defaultMessage='TRANSFER FROM GROUP'
            description='Transfer From Group label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={groupFromOptions}
              childChange={childChange}
              field='fromGroup'
              defaultValue={defaultFromGroup}
            />
          </div>
        </section>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.toGroup'
            defaultMessage='TRANSFER TO GROUP'
            description='Transfer To Group label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={groupToOptions}
              childChange={childChange}
              field='toGroup'
              defaultValue={defaultToGroup}
            />
          </div>
        </section>
        <section className={styles.userInput}>
          <FormattedMessage
            id='customer.transferDevices.toCustomer'
            defaultMessage='TRANSFER TO CUSTOMER'
            description='Transfer To Customer label'
            tagName='h5'
          />
          <div className={styles.userInputValueEdit}>
            <SelectInput
              options={customerOptions}
              childChange={childChange}
              field='company'
              value={company}
              disabled
            />
          </div>
        </section>
      </div>

      <div>
        {selectAllButton}
        {gridList}
      </div>

      <CapitalButton
        text={formatMessage({
          id: 'customer.nextButton',
          defaultMessage: 'Next',
          description: '',
        })}
        buttonFunction={submitData}
        hSize='h2'
        style={saveButtonStyle}
        disabled={invalid}
      />
    </div>
  )
}

export default injectIntl(ExistingCustomerStep2)
